<app-navbar [title]="pageTitle">
	<button class="btn btn-warning me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="deleteAsk()">
		<i class="fas fa-trash-alt"></i> Usuń
	</button>
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		<i class="fas fa-check"></i> Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		<i class="fas fa-pencil-alt"></i> Edycja
	</button>
	<a class="btn btn-danger" routerLink="/tourist-guides-calendar/"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<div class="container my-4">
	<form (submit)="submit()">
		<fieldset [disabled]="pageFunction !== 'add' && !editable">
			<div class="mb-3 row">
				<ng-select
					id="touristGuides"
					name="touristGuides"
					[(ngModel)]="data.touristGuides"
					[multiple]="true"
					placeholder="Piloci"
					[disabled]="pageFunction !== 'add' && !editable"
				>
					<ng-option *ngFor="let item of touristGuides" [value]="item.id">
						{{ item.lastName }} {{ item.firstName }}
					</ng-option>
				</ng-select>
			</div>
			<div class="form-floating mb-3">
				<select class="form-select" id="type" name="type" [(ngModel)]="data.type" required>
					<option value="{{ item.id }}" *ngFor="let item of types">{{ item.name }}</option>
				</select>
				<label for="type">Rodzaj</label>
			</div>
			<div class="form-floating mb-3">
				<input
					type="datetime-local"
					class="form-control"
					id="date_from"
					name="date_from"
					[appUtcModel]="data.date_from"
					(appUtcModelChange)="data.date_from = $event"
				/>
				<label for="date_from">Data od</label>
			</div>
			<div class="form-floating mb-3">
				<input
					type="datetime-local"
					class="form-control"
					id="date_to"
					name="date_to"
					[appUtcModel]="data.date_to"
					(appUtcModelChange)="data.date_to = $event"
				/>
				<label for="date_to">Data do</label>
			</div>

			<div class="form-floating mb-3">
				<textarea
					class="form-control"
					id="comments"
					name="comments"
					[(ngModel)]="data.comments"
					required
				></textarea>
				<label for="comments">Komentarz</label>
			</div>
		</fieldset>
	</form>
</div>
